<template>
  <div>
    <div v-if="isloading" class="justify-center d-flex">
      <v-progress-circular
        :size="small ? 30 : 50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <div class="justify-center d-flex">
      <v-chip-group v-if="Balance.length" column light>
        <template v-for="(item, index) in Balance">
          <v-chip
            :small="small"
            :color="colorName"
            outlined
            :key="index + 'cashView'"
            ><strong
              >{{ item.AccountName ? item.AccountName : "Total" }}:
              <span class="indigo--text">
                {{ item.Amount.toLocaleString() }}
                <span v-if="item.AmountType" :class="CashColor + '--text'">{{
                  item.AmountType
                }}</span>
              </span></strong
            >
          </v-chip>
        </template>
      </v-chip-group>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    Balance: { type: [Array, String], default: () => [] },
    isloading: { type: Boolean },
    small: { type: Boolean, default: false },
    colorName: { type: String, default: "indigo" },
    CashColor: { type: String, default: "error" },
  },
};
</script>
<style scoped>
span {
  /* border-bottom: solid double 2px black; */
  border-bottom: double black;
}
</style>
